import request from '@/utils/request'

/*
 * 查询购物车
 */
export function fetchCart (taxonomy) {
  return request.request(
    `/cart`,
    {taxonomy},
    {method: 'get'}
  )
}

/*
 * 下订单
 */
export function createOrder (cartIds, taxonomy) {
  return request.request(
    `/order`,
    {
      cart_ids: cartIds,
      manuscript_id: '',
      taxonomy: taxonomy
    },
    {method: 'POST'}
  )
}



// WEBPACK FOOTER //
// ./src/api/cart.js